<template>
    <div v-if="markerCoordinates.length>0"
         class="google-map"
         :id="mapName">
    </div>
</template>
<script>
    export default {
        name: 'google-map',
        props: {
            name: String,
            resize: String,
            redraw: String,
            zoom: {
                type: Number,
                default: function () {
                    return -1
                }
            },
            markerCoordinates: {
                type: Array,
                required: false,
                default: function () {
                    return []
                }
            },
        },
        methods: {
            createMap: function () {
                this.bounds = new google.maps.LatLngBounds();
                const element = document.getElementById(this.mapName)
                if (this.markerCoordinates.length <= 0)
                    return
                const mapCentre = this.markerCoordinates[0]
                const options = {
                    center: new google.maps.LatLng(mapCentre.latitude, mapCentre.longitude)
                }
                this.map = new google.maps.Map(element, options);
                this.markerCoordinates.forEach((coord) => {
                    const position = new google.maps.LatLng(coord.latitude, coord.longitude);
                    const marker = new google.maps.Marker({
                        position,
                        map: this.map
                    });
                    this.markers.push(marker)
                    if (this.zoom == -1)
                        this.map.fitBounds(this.bounds.extend(position))
                    else
                        this.map.setZoom(this.zoom)
                });
            }
        },
        data: function () {
            return {
                mapName: this.name + "-map",
                map: null,
                bounds: null,
                markers: []
            }
        },
        watch: {
            'resize': function () {
                // this.$consoleLog('resizec')
                this.createMap();
            },
            'redraw': function() {
                this.createMap()
            }
        },
        mounted: function () {
            this.createMap();
        }
    };
</script>

<style scoped>
    .google-map {
        width: 100%;
        min-height: 500px;
        margin: 0 auto;
        background: gray;
    }
</style>


// WEBPACK FOOTER //
// src/components/Communs/googleMap.vue